import { AuthService } from "shared/mechanics/auth";
import { catchErrors, skipForDevelopment, skipForPrerender } from "shared/mechanics/decorators";
import { Logger } from "shared/mechanics/logging";
import { IPlugin } from "shared/mechanics/plugin";

import { initYandexMetrika } from './external-code';

declare const ym: any;

const measurementId = process.env.REACT_APP_INTEGRATION_YANDEX_MEASUREMENT_ID;

export interface IYandexAnalyticsPlugin extends IPlugin {
	trackVisit(visitUrl: string, title: string, params: { [key: string]: string }): void;
	reachGoal(goalSystemName: string): void;
}

export class YandexAnalyticsPlugin implements IYandexAnalyticsPlugin {
	isInitialized: boolean = false;
	name: string = 'Yandex metrika';
	
	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	init(): void {
		initYandexMetrika();

		const userParams: any = {};
		
		const currentUser = AuthService.resolveUserInfo();
		if (currentUser) {
			userParams.UserID = currentUser.id;
		}

		ym(measurementId, 'init', {
			defer: true,
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true,
			userParams: userParams
		});

		this.isInitialized = true;
	}

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	trackVisit(visitUrl: string, title: string, params: { [key: string]: string; }): void {
		if (!this.isInitialized) {
			Logger.logWarning('Yandex analytics was not initialized');
			return;
		}

		ym(measurementId, 'hit', visitUrl, { title: title, params });
	}
	
	reachGoal(goalSystemName: string): void {
		if (!this.isInitialized) {
			Logger.logWarning('Yandex analytics was not initialized');
			return;
		}

		ym(measurementId,'reachGoal', goalSystemName);
	}
}
